<template>
    <div class="w-list-filter">
        <div class="w-list-filter__inner">
            <div class="w-list-filter__input">
                <input
                    type="text"
                    v-model="input"
                    @keyup="enterKey"
                    placeholder="Nach Spiel suchen…"
                />
                <button
                    @click="reset"
                    :disabled="!hasReset && loading"
                    :class="{ 'w-is-disabled': !hasReset }"
                    class="w-list-filter__button w-list-filter__button--delete"
                    title="Zurücksetzen"
                >
                    <icon data="@icons/backspace.svg" /><span class="w-u-hide"
                        >Zurücksetzen</span
                    >
                </button>
                <button
                    @click="submit"
                    :disabled="!hasSubmit && loading"
                    :class="{ 'w-is-disabled': !hasSubmit }"
                    class="w-list-filter__button w-list-filter__button--search"
                    title="Suchen"
                >
                    <icon
                        width="32"
                        height="32"
                        data="@icons/search.svg"
                    /><span class="w-u-hide">Suchen</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListFilter',
    data() {
        return {
            input: '',
        };
    },
    computed: {
        hasSubmit() {
            return this.input !== '' && this.input !== this.$store.state.query;
        },
        hasReset() {
            return this.$store.state.query !== '';
        },
        loading() {
            return this.$store.state.loading;
        },
    },
    methods: {
        enterKey: function(e) {
            if (e.target.value === '') {
                this.reset();
            }
            if (e.keyCode === 13) {
                e.target.blur();
                this.submit();
            }
        },
        submit() {
            if (this.input !== '') {
                this.$store.commit('setQuery', this.input);
                this.$store.dispatch('gotoPage');
            }
        },
        reset() {
            this.input = '';
            this.$store.commit('setQuery', this.input);
            this.$store.dispatch('gotoPage');
        },
    },
};
</script>

<style lang="scss">
@import '@/styles/_base.scss';
@import "@/styles/objects/_format.scss";

.w-list-filter {
}
.w-list-filter__inner {
    text-align: center;
    padding: 0 $w-gutter;
}
.w-list-filter__input {
    position: relative;
    display: inline-flex;

    max-width: 40em;
    min-width: 18em;
    width: 100%;

    border: 1px solid w-get-color("bordergray");
    &:focus-within {
        border-color: w-get-color("green");        
    }

    input {
        @include w-o-format("term");

        flex: 0 0 100%;
        max-width: 100%;

        appearance: none;
        display: block;
        box-shadow: none;
        border: none;
        padding: 0.5em 1.8em;
        height: 2em;

        &:focus {
            outline: none;
        }
        &::placeholder {
            color: w-get-color("bordergray");
            opacity: 1;
        }
    }
    button {
        flex: 0 0 auto;
    }
}
.w-list-filter__button {
    position: absolute;
    display: block;
    height: 3em;
    width: 3em;
    top: 0;
    text-align: center;

    &.w-list-filter__button--delete {
        right: 0;
        
        &[disabled],
        &.w-is-disabled {
            display: none;
        }
    }
    &.w-list-filter__button--search {
        left: 0;

        &[disabled],
        &.w-is-disabled {
            opacity: 0.25;
            pointer-events: none;
        }
    }

    color: w-get-color("darkgray");
    &:focus,
    &:hover {
        color: w-get-color("green");
    }
}
</style>
